import { render } from "./Pagination.vue?vue&type=template&id=5fb1e3eb"
import script from "./Pagination.vue?vue&type=script&lang=ts"
export * from "./Pagination.vue?vue&type=script&lang=ts"

import "./Pagination.vue?vue&type=style&index=0&id=5fb1e3eb&lang=scss"
script.render = render

export default script